<template>
  <div class="logout-modal standout">
    <p class="header">YOU ARE LEAVING YOUR PATHFINDER</p>
    <p class="subheader">You can always come back, just make sure to remember their name</p>
    <p class="name">{{ pathfinder.name }}</p>
    <img src="@/assets/icons/write.svg">
    <p class="write">WRITE IT DOWN ON A CARD</p>
    <button
      class="button warning"
      @click="$parent.close()"
    >NEVERMIND, I'LL STAY HERE</button>
    <button
      class="button primary"
      @click="logout()"
    >EXIT</button>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  export default {
    props: ["pathfinder"],
    methods: {
      logout() {
        this.$router.replace("/");
      }
    }
  };
</script>

<style lang="scss">
  @import "@/assets/global.scss";
  .logout-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 95%;
    margin: auto;

    p {
      text-align: center;
    }

    .header {
      font-size: 1.5em;
      font-weight: bold;
      width: 80%;
      margin-bottom: 0.5em;
    }

    .subheader {
      font-style: italic;
      width: 80%;
      color: $primary;
      margin-bottom: 1em;
    }

    .name {
      font-size: 2em;
      padding: 0.25em;
      background-color: #93509f;
      margin-bottom: 0.5em;
    }

    .write {
      font-size: 0.75em;
      font-weight: bold;
      color: #52245c;
    }

    button {
      font-size: 0.8em;
      margin-top: 0.5em;
      width: 80%;
      height: 3em;
    }

    button.warning {
      font-size: 0.7em;
    }

    button.primary {
      margin-top: 1em;
    }
  }
</style>
